/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { TemplateManagementCommandBarContainer as TemplateManagementCommandBar } from './TemplateManagementCommandBar.container';
